import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const scrollToContact = () => {
  const contactSection = document.getElementById('contact');
  if (contactSection) {
    contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    window.dispatchEvent(new CustomEvent('openContactForm'));
  }
};

const PricingSection = () => {
  const { t, tArray } = useLanguage();

  const plansData = tArray('pricing.plans');
  const plans = plansData.map((plan, index) => ({
    ...plan,
    featured: index === 1
  }));

  return (
    <section id="pricing" className="landing-section landing-section-alt landing-section-light">
        <div className="container-landing">
          <div className="text-center">
            <h2 className="section-title">{t('pricing.title')}</h2>
            <p className="section-subtitle">
              {t('pricing.subtitle')}
            </p>
          </div>

          <div className="pricing-grid">
            {plans.map((plan, index) => (
              <div 
                key={index} 
                className={`pricing-card ${plan.featured ? 'featured' : ''}`}
              >
                <h3 className="pricing-plan-name">{plan.name}</h3>
                <div className="pricing-amount">{plan.price}</div>
                <div className="pricing-period">{plan.period}</div>
                
                <ul className="pricing-features">
                  {plan.features.map((feature, idx) => (
                    <li key={idx}>✓ {feature}</li>
                  ))}
                </ul>

                <button 
                  className="pricing-btn"
                  onClick={scrollToContact}
                >
                  {plan.buttonText}
                </button>
              </div>
            ))}
          </div>

          <div className="text-center mt-4" style={{ marginTop: '3rem' }}>
            <p style={{ color: '#666', fontSize: '1rem' }}>
              {t('pricing.disclaimer')}
            </p>
            <p style={{ color: '#666', fontSize: '0.9rem', marginTop: '1rem' }}>
              {t('pricing.note')}
            </p>
          </div>
        </div>
      </section>
  );
};

export default PricingSection;
